import React, { useEffect, useState } from "react";
import { Table, Pagination, Button } from "react-bootstrap";
import "./user-management-table.component.scss";
import PREVIEW_ICON from "../../../assets/images/preview.svg";
import TRASH_ICON from "../../../assets/images/trash.svg";
import CHECK_GREEN from "../../../assets/images/check-green.svg";
import NOT_COMPLETE from "../../../assets/images/not-complete.svg";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../shared/custom-pagination/custom-pagination.component";
import { ProfileModel } from "../../../model/profile.model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faClock, faEdit } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../utility/use-auth";
const UserManagementTableWithPagination = ({ listUsersMod, clickDeleteUser, clickEditUser }) => {
    const [listUsers, setListUsers] = useState<ProfileModel[]>(listUsersMod);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (listUsersMod) {
            setListUsers(listUsersMod);
        }
    }, [listUsersMod])
    const convertToThaiDate = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, "0"); // Get day with leading zero
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Get month with leading zero
        const year = date.getFullYear() + 543; // Convert to Buddhist Year (B.E.)

        return `${day}/${month}/${year}`; // Format: DD MM YYYY (พ.ศ.)
    };


    return (
        <div className="user-management-table-control">
            <Table className="user-management-table-th-control">
                <thead>
                    <tr  >
                        <th className="user-management-table-content">#</th>
                        <th >อีเมล</th>
                        <th className="user-management-table-content">บทบาท</th>
                        <th className="user-management-table-content">เข้าสู่ระบบล่าสุด</th>
                        <th className="user-management-table-content">สถานะ</th>
                        <th className="user-management-table-content"></th>
                    </tr>
                </thead>
                <tbody >
                    {listUsers.map((row, index) => (
                        <tr key={row.uuid} className="user-management-table-row-control" >
                            <td>{index + 1}</td>
                            <td >{row.email}</td>
                            <td className="user-management-table-content">{row.role}</td>
                            <td className="user-management-table-content">{row.last_login ? convertToThaiDate(row.last_login) : "-"}</td>
                            <td className="user-management-table-content">
                                {row.status == "verified" ? (
                                    <span className="user-management-table-status-text">
                                        <FontAwesomeIcon icon={faCheckCircle} className="user-management-table-status-icon" />
                                        ยืนยันตัวตนแล้ว
                                    </span>
                                ) : (
                                    <span className="user-management-table-status-text-not-complete">
                                        <FontAwesomeIcon icon={faClock} className="user-management-table-status-icon" />
                                        ส่งคำเชิญแล้ว
                                    </span>
                                )}
                            </td>
                            <td>
                                {
                                    (user && user.email != row.email && user.role === "Super Admin") && <FontAwesomeIcon icon={faEdit} onClick={() => clickEditUser(row)} className="user-management-table-preview-icon-edit" />
                                }
                                {
                                    (user && user.email != row.email && row.role == "Admin" && user.role === "Super Admin") && <img src={TRASH_ICON} onClick={() => clickDeleteUser(row)} className="user-management-table-preview-icon"></img>
                                }
                                {
                                    (user && user.email != row.email && row.role == "Staff") && (user.role === "Super Admin" || user.role === "Admin") && <img src={TRASH_ICON} onClick={() => clickDeleteUser(row)} className="user-management-table-preview-icon"></img>
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

        </div>
    );
};

export default UserManagementTableWithPagination;
